<template>
    <section class="has-pt-6 has-bg-gray-10 search-filter-module">
        <h1 class="screen-reader-only">Search results for</h1>
        <form id="search-form" data-total-pages="0" action="#">
            <div class="container is-narrow">
                <div class="has-mt-3 has-pb-3">
                    <div class="is-d-flex">
                        <DelayedInput 
                            v-model="searchTerm" 
                            id="vue-search-input" 
                            class="has-bg-gray-0" 
                            type="search" 
                            autocomplete="off"
                            required 
                            aria-label="Search" 
                            placeholder="eg. Depression" 
                        />
                        <button class="btn is-branddark has-ml-3" @click="preventSubmit">Search</button>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    import DelayedInput from "./DelayedInput";

    export default {
        name: "SearchForm",
        components: {
          DelayedInput,
        },          
        computed: {
            searchTerm: {
                get() {
                    return this.$store.state.searchTerm;
                },
                set(value) {
                    this.$store.commit('setSearchTerm', value);                  
                }
            }        
        },
        methods: {
            preventSubmit(e) {
                e.preventDefault();
            },
        },
    }
</script>